import { SearchEmptyIcon } from './icons'

export function SearchEmptyState() {
	return (
		<div className='flex min-h-[200px] flex-col items-center justify-center gap-3 py-10 text-center'>
			<SearchEmptyIcon className='h-28 w-28 text-muted-foreground' />
			<div className='space-y-1'>
				<p className='text-base font-semibold text-foreground'>No results found</p>
				<p className='text-sm text-muted-foreground'>Check your request or try another</p>
			</div>
		</div>
	)
}
